export enum TripPatternCheckpointType {
    START_END = 1, // Inicio - Fin
    INTERMEDIATE = 2, // Intermedio
    END_START = 3  // Fin - Inicio
}